module.exports = __webpack_public_path__ + "img/NW11.f50ad92a.gif";